export default [
  {
    title: '【客户手册】Aegis Mentee Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/【客户手册】Aegis Mentee Guide.pdf',
    roles: ['NORMAL'],
    packs: ['AEGIS']
  },
  {
    title: '【客户手册】Classic Lite- Mentee Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/【客户手册】Classic Lite- Mentee Guide.pdf',
    roles: ['NORMAL'],
    packs: ['CLASSICLITE']
  },
  {
    title: '【客户手册】Classic Mentee Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/【客户手册】Classic Mentee Guide.pdf',
    roles: ['NORMAL'],
    packs: ['CLASSIC']
  },
  {
    title: '【客户手册】Premier Mentee Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/【客户手册】Premier Mentee Guide.pdf',
    roles: ['NORMAL'],
    packs: ['PREMIER']
  },
  {
    title: '【客户手册】Premier Plus Mentee Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/【客户手册】Premier Plus Mentee Guide.pdf',
    roles: ['NORMAL'],
    packs: ['PREMIERPLUS']
  },
  {
    title: '【客户手册】Development Mentee Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/%E3%80%90%E5%AE%A2%E6%88%B7%E6%89%8B%E5%86%8C%E3%80%91Development%20Mentee%20Guide.pdf',
    roles: ['NORMAL'],
    packs: ['DEVELOPMENT']
  },

  {
    title: '【客户手册】Plan C Mentee Guide',
    url: 'http://res.zailairen.com/msp/docs/ugd/1.0/%E3%80%90%E5%AE%A2%E6%88%B7%E6%89%8B%E5%86%8C%E3%80%91Plan%20C%20Mentee%20Guide.pdf',
    roles: ['NORMAL'],
    packs: ['PLANC']
  },
  {
    title: 'G. Voronkov Scholarship Mentee Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/G. Voronkov Scholarship Mentee Guide.pdf',
    roles: ['SCHOLAR'],
    packs: ['B1']
  },
  {
    title: 'J. Q. Fu Scholarship Mentee Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/J. Q. Fu Scholarship Mentee Guide .pdf',
    roles: ['SCHOLAR'],
    packs: ['A']
  },
  {
    title: 'J. Z. Chen Scholarship Mentee Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/J. Z. Chen Scholarship Mentee Guide .pdf',
    roles: ['SCHOLAR'],
    packs: ['S']
  },
  {
    title: 'M. G. Yan Scholarship Mentee Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/M. G. Yan Scholarship Mentee Guide .pdf',
    roles: ['SCHOLAR'],
    packs: ['C1']
  },
  {
    title: 'S. Voronkova Scholarship Mentee Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/S. Voronkova Scholarship Mentee Guide.pdf',
    roles: ['SCHOLAR'],
    packs: ['B2']
  },
  {
    title: 'W. Wang Scholarship Mentee Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/W. Wang Scholarship Mentee Guide .pdf',
    roles: ['SCHOLAR'],
    packs: ['C2']
  },
  {
    title: '再来人Zoom 操作手册-学员版',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/再来人Zoom 操作手册-学员版 .pdf',
    roles: []
  },
  {
    title: '再来人本科文书写作指南',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/再来人本科文书写作指南.pdf',
    roles: []
  },
  {
    title: '再来人本科申请-美国院校选校指南',
    url: 'https://res.zailairen.com/msp/docs/ugd/1.0/再来人本科申请-美国院校选校指南.pdf',
    roles: []
  },
  {
    title: '再来人本科面试指南',
    url: 'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/ugd/1.0/%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%9C%AC%E7%A7%91%E9%9D%A2%E8%AF%95%E6%8C%87%E5%8D%97.pdf',
    roles: []
  }
]
